export default {
    DELETED: 0, // Device has been removed, this isn't used any more but was kept for backwards compatibility
    ACTIVE: 1, // Actively tracking activity, synonymous with Active Activity Tracker
    NOT_ACTIVE: 2, // Usually Retired
    ACTIVE_NOT_TRACKING: 3 // Device is capable of tracking activity, but isn't currently
};
